import { render, staticRenderFns } from "./form-textarea.vue?vue&type=template&id=1f90732d&scoped=true&"
import script from "./form-textarea.vue?vue&type=script&lang=js&"
export * from "./form-textarea.vue?vue&type=script&lang=js&"
import style0 from "./form-textarea.vue?vue&type=style&index=0&id=1f90732d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90732d",
  null
  
)

export default component.exports